import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site-config';

export default function CategoryNav() {
  return (
    <section className="py-6 md:py-8 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="flex flex-wrap items-center justify-center gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 text-foreground-700 font-label text-sm font-medium hover:bg-primary-50 hover:text-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap group"
            >
              <i className={`${cat.icon} text-base group-hover:text-primary-500 transition-colors`} />
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}